import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getAnalytics, logEvent as logAnalyticsEvent } from 'firebase/analytics';
import { CODE_GAMEPAD_URL } from './endpoints.config';

// Your web app's Firebase configuration
export const firebaseConfig = {
    apiKey: 'AIzaSyBKtC41EuAQIJLUZ6HSE0AoWvfwOb8ef2Q',
    authDomain: 'unboared-b2b.firebaseapp.com',
    projectId: 'unboared-b2b',
    storageBucket: 'unboared-b2b.appspot.com',
    messagingSenderId: '334911476740',
    appId: '1:334911476740:web:a191a626c9a466322e9151',
};

const app = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(app);

// Safari's default Firestore transport (WebChannel streaming) can fail to establish
// and pile up retrying Listen streams that hang ~60s, freezing console navigation.
// Force long-polling on Safari only; other browsers keep the default streaming
// transport (unchanged behaviour). Diagnosed on a client's Safari, 2026-06.
const isSafari =
    typeof navigator !== 'undefined' && /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);
export const db = initializeFirestore(app, isSafari ? { experimentalForceLongPolling: true } : {});

/**
 * Analytics n'est PAS chargé sur la manette.
 *
 * `getAnalytics()` entraîne Firebase Installations, qui a besoin du réseau et d'IndexedDB.
 * Sur le téléphone d'un joueur (4G capricieuse, onglet mis en veille par iOS, Safari qui
 * vide le stockage), ces appels échouent en rejets non capturés : ~15 des 24 erreurs
 * remontées à Sentry le 09/09 venaient de là (`Installations: Application offline`,
 * `Database deleted by request of the user`, `TypeError: Load failed`). Une page manette
 * n'émet aucun événement Analytics (aucun appel à `logEvent` sous `/gamepad`), donc c'est
 * du réseau et du stockage dépensés pour rien sur l'appareil des joueurs.
 *
 * Le reste de l'app (console, pages marketing, écran) garde le chargement immédiat : les
 * `page_view` automatiques alimentent le tunnel d'inscription GA4, il ne faut pas les perdre.
 */
const isGamepadRoute = typeof window !== 'undefined' && window.location.pathname.startsWith(`/${CODE_GAMEPAD_URL}`);

export const analytics = isGamepadRoute ? undefined : getAnalytics(app);

function logEvent(eventName: string, screenName: string = '', callbackFunction: any = undefined) {
    if (analytics) {
        if (callbackFunction && typeof callbackFunction === 'object') {
            logAnalyticsEvent(analytics, eventName, {
                firebase_screen: screenName,
                ...callbackFunction,
            });
        } else {
            logAnalyticsEvent(analytics, eventName, {
                firebase_screen: screenName,
            });
        }
    }
    // Le callback de navigation doit s'exécuter même sans Analytics : c'est lui qui fait
    // avancer l'utilisateur (ex. `logEvent('button_click', …, () => navigate('/signup'))`).
    if (callbackFunction && typeof callbackFunction === 'function') {
        callbackFunction();
    }
}

export { logEvent };
